// =============================================================================
// AI provider and model constants — used by admin UI for provider selection
// =============================================================================

export const AI_PROVIDERS = [
  { code: 'anthropic', name: 'Anthropic' },
  { code: 'openai', name: 'OpenAI' },
  { code: 'gemini', name: 'Google Gemini' },
] as const;

export type AIProviderCode = (typeof AI_PROVIDERS)[number]['code'];

export const AI_MODELS: Record<AIProviderCode, { id: string; name: string }[]> = {
  anthropic: [{ id: 'claude-sonnet-4-5-20250929', name: 'Claude Sonnet 4.5' }],
  openai: [
    { id: 'gpt-4o', name: 'GPT-4o' },
    { id: 'gpt-4o-mini', name: 'GPT-4o mini' },
    { id: 'gpt-5', name: 'GPT-5' },
    { id: 'gpt-5-mini', name: 'GPT-5 Mini' },
    { id: 'gpt-5-nano', name: 'GPT-5 Nano' },
  ],
  gemini: [
    { id: 'gemini-2.0-flash', name: 'Gemini 2.0 Flash' },
    { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash' },
  ],
};

export const DEFAULT_AI_PROVIDER: AIProviderCode = 'anthropic';
export const DEFAULT_AI_MODEL = 'claude-sonnet-4-5-20250929';
